import { Formik } from 'formik';
import * as Yup from "yup";
import React, { useState } from 'react';
import { Alert, Button, Col, Form, Input, InputGroup, Label, Row, Spinner } from 'reactstrap';
import { PostData } from '../../../services/FetchData';
import { useLocation, useNavigate } from 'react-router-dom';
import DrupalConnectGuide from './DrupalConnectGuide';

const findApiKey = (websiteKeys) => {
	if (!Array.isArray(websiteKeys)) {
		return null;
	}
	const keyRow = websiteKeys.find(key => key.websiteIntegrationKey === "apiKey");
	return keyRow ? keyRow.websiteIntegrationValue : null;
}

const CollectDrupal = () => {
	const navigate = useNavigate(),
		location = useLocation(),
		productType = location.state?.productType,
		showProductSelection = !productType,
		[errorMessages, setErrorMessages] = useState(""),
		[connectDetails, setConnectDetails] = useState(null);

	const initialSearchProduct = productType === "aiassistant" ? false : true;
	const initialAiAssistantProduct = productType === "aiassistant";

	const saveDrupalStore = async (values, actions) => {
		const payload = {
				storeName: values.storeName,
				storeURL: values.storeURL,
				storeType: "drupal"
			},
			details = { storeURL: values.storeURL, searchApiKey: null, aiAssistantApiKey: null };
		let anySaved = false;

		try {
			if (values.searchProduct) {
				const result = await PostData("ms1", "api/v1/website/drupal/saveStore", payload);
				if (result !== "Invalid" && result !== undefined && result.status === "success") {
					details.searchApiKey = result.data?.apiKey ?? null;
					anySaved = true;
				} else {
					setErrorMessages(result?.message?.message ?? result?.message ?? "Unable to save Search store");
				}
			}

			if (values.aiAssistantProduct) {
				const result = await PostData("ms1", "api/v1/website/saveAiAssistantStore", payload);
				if (result !== "Invalid" && result !== undefined && result.status === "success") {
					details.aiAssistantApiKey = findApiKey(result.data?.websiteKeys);
					anySaved = true;
				} else {
					setErrorMessages(result?.message?.message ?? result?.message ?? "Unable to save AI Assistant store");
				}
			}

			if (anySaved) {
				if (details.searchApiKey && !details.aiAssistantApiKey) {
					navigate("/getStarted/drupalApiKey", {
						state: {
							websiteId: null,
							apiKey: details.searchApiKey
						},
						replace: true
					});
				} else {
					setConnectDetails(details);
				}
			}
		} finally {
			actions.setSubmitting(false);
		}
	}

	if (connectDetails) {
		return <DrupalConnectGuide {...connectDetails} />
	}

	const validationShape = {
		storeName: Yup.string().required("Store name is required"),
		storeURL: Yup.string().required("Store URL is required").url("Please enter valid store URL"),
		aiAssistantProduct: Yup.boolean().test(
			"atLeastOneProduct",
			"Select at least one product",
			function (value) {
				return Boolean(value) || Boolean(this.parent.searchProduct);
			}
		)
	};

	return (
		<>
			<section className='choosePlatformHeader'>
				<div className='container'>
					<Row className="align-items-center justify-content-center">
						<Col xs={"auto"}>
							<h2 className='mt-5'>Store Information</h2>
						</Col>
					</Row>
				</div>
			</section>
			<section className='shopifyAppInstallationGuide mt-5'>
				<div className='container'>
					<Row className='align-items-center justify-content-center'>
						<Col xs={12} lg={6} className='text-center d-none d-lg-block'>
							<img src={require("./../../../assets/images/integration.png")} alt="integration" className='img-fluid' />
						</Col>
						<Col xs={12} lg={6}>
							{errorMessages !== "" && (
								<Alert color="danger">
									{errorMessages}
								</Alert>
							)}
							<div className='storeInformationWrapper'>
								<Formik
									enableReinitialize
									initialValues={{
										storeName: "",
										storeURL: "",
										searchProduct: initialSearchProduct,
										aiAssistantProduct: initialAiAssistantProduct
									}}
									onSubmit={(values, actions) => {
										saveDrupalStore(values, actions)
									}}
									validationSchema={Yup.object().shape(validationShape)}
								>
									{formProps => {
										const {
											values,
											touched,
											errors,
											isSubmitting,
											handleChange,
											handleBlur,
											handleSubmit
										} = formProps;
										return (
											<Form role="form" onSubmit={handleSubmit} noValidate>
												<div className={`position-relative mb-5 ${(errors.storeName && touched.storeName && "error_field")}`}>
													<Label className="input-group-alternative-label" >
														Store Name
													</Label>
													<InputGroup className="input-group-alternative">
														<Input
															placeholder="Store Name"
															type="text"
															name="storeName"
															value={values.storeName}
															onChange={handleChange}
															onBlur={handleBlur}
															autofill="false"
															className={
																"col" || (errors.storeName && touched.storeName && "error")
															}
														/>
													</InputGroup>
													{errors.storeName && touched.storeName && (
														<div className="input-feedback">{errors.storeName}</div>
													)}
												</div>
												<div className={`position-relative mb-5 ${(errors.storeURL && touched.storeURL && "error_field")}`}>
													<Label className="input-group-alternative-label" >
														Website URL
													</Label>
													<InputGroup className="input-group-alternative">
														<Input
															placeholder="Website URL"
															type={"text"}
															name="storeURL"
															value={values.storeURL}
															onChange={handleChange}
															onBlur={handleBlur}
															className={
																"col" ||
																(errors.storeURL && touched.storeURL && "error")
															}
															autofill="false"
														/>
													</InputGroup>
													{errors.storeURL && touched.storeURL && (
														<div className="input-feedback">{errors.storeURL}</div>
													)}
												</div>
												{showProductSelection && (
													<div className='position-relative mb-5 productSelectWrapper'>
														<Label className="input-group-alternative-label">
															Products
														</Label>
														<div className='d-flex flex-column gap3'>
															<Label check className='productSelectOption'>
																<Input
																	type="checkbox"
																	name="searchProduct"
																	checked={values.searchProduct}
																	onChange={handleChange}
																	onBlur={handleBlur}
																/>
																<span className='ml-2'>ConversionBox Search</span>
															</Label>
															<Label check className='productSelectOption'>
																<Input
																	type="checkbox"
																	name="aiAssistantProduct"
																	checked={values.aiAssistantProduct}
																	onChange={handleChange}
																	onBlur={handleBlur}
																/>
																<span className='ml-2'>ConversionBox AI Assistant</span>
															</Label>
														</div>
														{errors.aiAssistantProduct && (
															<div className="input-feedback">{errors.aiAssistantProduct}</div>
														)}
													</div>
												)}
												<div className="d-flex justify-content-center">
													{isSubmitting ? (
														<Button className="cta authCta" color="primary" type="button" disabled>
															<Spinner
																className="white mr-1"
																size="sm"
																color="light"
															/>
															<span className="ml-2 d-inline-block">Loading</span>
														</Button>
													) : (
														<Button className=" cta authCta " color="primary" type="submit">Save</Button>
													)}
												</div>
											</Form>)
									}}
								</Formik>
							</div>
						</Col>
					</Row>
				</div>
			</section>
		</>
	);
}

export default CollectDrupal;
